const PrfActivities = () => {
  mapboxgl.accessToken = 'pk.eyJ1IjoiY2Nid3Fwb3J0YWwiLCJhIjoiY2plcmdqcnB2MDYzbTM0dW13aWp6cXhnbiJ9.wnHy3esIvSyv_MdNX_nwqw';
  const map = new mapboxgl.Map({
      container: 'prf-activities-map',
      style: 'mapbox://styles/ccbwqportal/cjrqnxsjz0fhh2snqq1j8wdyz',
      zoom: 10,
      center: [-104.854032, 39.539983],
  });

  const nav = new mapboxgl.NavigationControl();
  map.addControl(nav, 'top-left');

  // Create a popup, but don't add it to the map yet.
  const popup = new mapboxgl.Popup({
    closeButton: true,
    closeOnClick: true
  });

  function createPopup(e) {
    // Change the cursor style as a UI indicator.
    map.getCanvas().style.cursor = 'pointer';

    const feature = e.features[0].properties;
    const coords = [e.lngLat.lng, e.lngLat.lat];

    // Populate the popup and set its coordinates
    // based on the feature found.
    popup.setLngLat(coords)
      .setHTML(feature.Name)
      .addTo(map);
  }

  // Create popup on hover
  map.on("mouseover", 'prf-points-8wd572', createPopup);
  map.on("mouseover", 'prf-lines-0blpd8', createPopup);
  map.on("mouseover", 'prf-polygons-31r9yj', createPopup);

  class PrfList {
    constructor() {
      this.container = document.querySelector('#prf-site-list');
      this.visible = false;
      this.data = [
        {
          "name": "1 - Destratification System"
        },
        {
          "name": "2 - Arapahoe Road Sediment Basin"
        },
        {
          "name": "3 - Cherry Creek at Corner Star"
        },
        {
          "name": "4 - West Boat Ramp Parking Lot"
        },
        {
          "name": "5 - East Boatramp Shoreline Stabilization"
        },
        {
          "name": "6 - Dixon Grove Shoreline Stabilization"
        },
        {
          "name": "7 - East Shade Shelter"
        },
        {
          "name": "8 - Tower Loop Shoreline Stabilization"
        },
        {
          "name": "9 - East Shade Shelter Ph II"
        },
        {
          "name": "10 - East Boat Ramp Ph II"
        },
        {
          "name": "11 - Rueter Hess Diversion"
        },
        {
          "name": "12 - Cherry Creek at Eco Park"
        },
        {
          "name": "13 - Cherry Creek at PJCOS"
        },
        {
          "name": "14 - Cottonwood Creek at Easter Avenue"
        },
        {
          "name": "15 - Cottonwood Stream Reclamation Ph I and II"
        },
        {
          "name": "16 - McMurdo Gulch"
        },
        {
          "name": "17 - Quincy Drain"
        },
        {
          "name": "18 - Shop Creek Wetlands"
        },
        {
          "name": "19 - Cherry Creek at 12-Mile Park-Ph I"
        },
        {
          "name": "20 - WBR-Storm"
        },
        {
          "name": "21 - Mountain and Lake Loop Shoreline Stabilization"
        },
        {
          "name": "22 - Cherry Creek at Norton Open Space/Farms"
        },
        {
          "name": "23 - Cherry Creek CCSP to EcoPark"
        },
        {
          "name": "25 - Cherry Creek at Country Meadows"
        },
        {
          "name": "26 - Cherry Creek d/s Piney Creek"
        },
        {
          "name": "27 - Cherry Creek at 12-Mile Park Ph II"
        },
        {
          "name": "28 - Bowtie Project"
        },
        {
          "name": "29 - Cherry Creek at Lincoln Ave"
        },
        {
          "name": "30 - Cherry Creek at Main Street"
        },
        {
          "name": "31 - Hess Rd. Extension Proj."
        },
        {
          "name": "32 - Cottonwood Creek at Inverness"
        },
        {
          "name": "33 - Cherry Creek at Pine Lane"
        },
        {
          "name": "34 - Piney Creek Stream Reclamation"
        },
        {
          "name": "35 - Cherry Creek at Cottonwood Bridge"
        },
        {
          "name": "36 - Cherry Creek at Stroh Road"
        },
        {
          "name": "37 - Cherry Creek Open Space"
        },
        {
          "name": "38 - Trib B Airport EDB East"
        },
        {
          "name": "39 - Trib B Airport EDB West"
        },
        {
          "name": "40 - Cottonwood Wetlands"
        },
        {
          "name": "41 - Cottonwood Creek Peoria Pond"
        },
        {
          "name": "42 - WBR Pond"
        },
        {
          "name": "43 - Piney Creek Reach 6"
        },
        {
          "name": "44 - Piney Creek Reach 7"
        },
        {
          "name": "45 - Peoria Pond Interpretive Sign Replacement"
        }
      ];
      this.init();
    }

    bindEvents() {
      const { container } = this; 
      const btn = container.querySelector('.btn');
      btn.addEventListener('click', this.toggleDisplay.bind(this));
    }

    toggleDisplay() {
      const { container } = this;
      const btn = container.querySelector('.btn');
      const list = container.querySelector('.prf-list');
      const classList = list.classList;
      if (classList.contains('hidden')) {
        list.classList.remove('hidden');
        btn.textContent = 'Hide Sites';
      } else {
        list.classList.add('hidden');
        btn.textContent = 'Show Sites';
      }
      return this;
    }

    build() {
      const { container, data } = this;
      const list = document.createElement('ul');
      list.classList += 'prf-list hidden';
      const lis = data.map((d) => {
        const li = document.createElement('li');
        li.textContent = d.name;
        list.appendChild(li);
      });
      container.appendChild(list);
      return this;
    }

    init() {
      this.bindEvents();
      this.build();
      return this;
    }
  }

  const prfList = new PrfList();
};
